import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from 'express';
import { AppConstants } from 'src/app/core/constants';
import { Faq } from 'src/app/core/models/faq.model';
import { FaqService } from 'src/app/core/services/faq.service';

@Component({
  selector: 'app-invest-faq',
  templateUrl: './invest-faq.component.html',
  styleUrls: ['./invest-faq.component.scss',],
})
export class InvestFaqComponent implements OnInit {
  investFaqs: Faq[] = [];
  selectedInvestFaq?: Faq;
  selectedInvestFaqIndex = AppConstants.ZERO;

  constructor(
    private _faqService: FaqService,
    @Inject(PLATFORM_ID) private readonly _platformId: Object
  ) { }
  ngOnInit(): void {
    if (isPlatformBrowser(this._platformId)) this._getInvestFaqs();
  }

  _getInvestFaqs() {
    this._faqService.getInvestFaqs().subscribe({
      next: (data: Faq[]) => {
        this.investFaqs = data;
        this.updateInvestFaqs();
      },
    });
  }

  updateInvestFaqs() {
    this.selectedInvestFaq = this.investFaqs[this.selectedInvestFaqIndex];
  }

  onCorporateFaqSelect(index: number) {
    this.selectedInvestFaqIndex = index;
    this.updateInvestFaqs();
  }

  toggleInvestFaq(index: number) {
    if (!this.selectedInvestFaq) return;
    this.selectedInvestFaq.faqs[index].isOpen = !this.selectedInvestFaq.faqs[index].isOpen;
  }
}
